import React, { Fragment } from 'react'
import { Separator, SpacerVertical, Typography } from '@klarna/bubble-ui'
import styles from './PaymentMethodDetails.css'
import { FiscPaymentDetailsProps, InstallmentPaymentDetailsProps } from '../../types'

const InstallmentPaymentDetails: React.FC<InstallmentPaymentDetailsProps | FiscPaymentDetailsProps> = ({
  installmentsTotal = '',
  totalTranslation = '',

  aprTranslation = '',
  apr = '',
  interestTranslation = '',
  interestAmount = '',
  isInterestGreaterThanZero = false,
  interestFreeTranslation = '',
  isConditionalApr = false,
  downPayment = '',
  dueTodayTranslation = '',
  showApr = false
}) => (
  <Fragment>
    <style>{styles}</style>
    <div className="details-container">
      {interestAmount ? (
        <div className="details-column-container">
          <Typography
            textToken="text-style/text/paragraphs/default/regular"
            colorToken={
              isInterestGreaterThanZero
                ? 'colors/text/neutral'
                : 'colors/text/success'
            }
            textAlignToken="text-alignment/center"
          >
            {`${interestAmount} ${isInterestGreaterThanZero ? interestTranslation : interestFreeTranslation}`}
            {(isInterestGreaterThanZero && !showApr) ? '*' : ''}
            {showApr && <div style={{ textAlign: 'left' }}>
              {`${apr}% ${aprTranslation}${isConditionalApr ? '*' : ''}`}
            </div>}
          </Typography>
        </div>
      ) : null}
      {!downPayment && <div className="details-column-container">
        <Typography
          accessibilityPreset="paragraph"
          textToken="text-style/text/paragraphs/default/regular"
          colorToken="colors/text/neutral"
          textAlignToken="text-alignment/end"
        >
          {`${totalTranslation} ${installmentsTotal}`}
        </Typography>
      </div>}
    </div>
    {downPayment && <>
      <SpacerVertical spaceToken="space.100" />
      <Separator />
      <SpacerVertical spaceToken="space.50" />
      <div className="details-container">
        <div className="details-column-container">
          <Typography
            textToken="text-style/text/paragraphs/default/regular"
            colorToken="colors/text/neutral"
            textAlignToken="text-alignment/center"
          >
            {`${downPayment} ${dueTodayTranslation}`}
          </Typography>
        </div>
        <div className="details-column-container">
          <Typography
            accessibilityPreset="paragraph"
            textToken="text-style/text/paragraphs/default/regular"
            colorToken="colors/text/neutral"
            textAlignToken="text-alignment/end"
          >
            {`${totalTranslation} ${installmentsTotal}`}
          </Typography>
        </div>
      </div>
    </>}
  </Fragment>
)

export default InstallmentPaymentDetails
